
var Sticky = require('./dist/sticky.compile.js');

module.exports = Sticky;



// WEBPACK FOOTER //
// ./node_modules/sticky-js/index.js